module.exports = __webpack_public_path__ + "img/hyperrag.7b4d230d.svg";